<template>
    <div class="data-page-header">
        <div>
            <h2 class="data-page-title">{{ title }}</h2>
            <p v-if="subtitle" class="data-page-subtitle">{{ subtitle }}</p>
        </div>
        <div v-if="$slots.actions" class="data-page-actions">
            <slot name="actions" />
        </div>
    </div>
</template>
<script>
export default {
    name: 'PageHeader',

    props: {
        title: {
            type: String,
            required: true
        },
        subtitle: {
            type: String,
            default: ''
        }
    }
}
</script>
